import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const state = {
  user: null,
  loginError: null
};

const actions = {

  async loginUser({ commit }, data) {
    commit("SET_MESSAGE", "Loading");
    try {
      await firebase.auth().signInWithEmailAndPassword(data.email, data.password);
    } catch (error) {
      commit("SET_LOGIN_ERROR", error.message);
    } finally {
      commit("CLEAR_MESSAGE");
    }
  },

  verifyLogin({ commit }, id) {
    commit("SET_MESSAGE", "Verifying");
    return new Promise((resolve, reject) => {
      firebase.firestore()
        .collection("users")
        .doc(id)
        .get()
        .then(doc => {
          if (doc.exists && doc.data().role === "vodUser") {
            resolve(doc.data());
            commit("CLEAR_MESSAGE");
          } else {
            reject("Not a user");
            commit("CLEAR_MESSAGE");
          }
        }).catch(err => {
          reject(err);
          commit("CLEAR_MESSAGE");
        });

    });
  },

  logoutUser({ commit }) {
    firebase.auth().signOut().catch(console.error);
    commit("RESET_USER");
  },

  resetPassword({ commit }, email) {
    commit("SET_MESSAGE", "Sending");
    firebase.auth().sendPasswordResetEmail(email)
      .then(() => {
        commit("SET_MESSAGE", "Sent!");
        setTimeout(() => {
          commit("CLEAR_MESSAGE");
        }, 3000);
      }).catch(err => {
        commit("SET_LOGIN_ERROR", err.message);
        commit("CLEAR_MESSAGE");
      });
  },

  dismissLoginAlert({ commit }) {
    commit("RESET_LOGIN_ERROR");
  }
};

const mutations = {
  SET_LOGIN_ERROR(state, err) {
    state.loginError = err;
  },
  RESET_LOGIN_ERROR(state) {
    state.loginError = null;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  RESET_USER(state) {
    state.user = null;
  }
};

const getters = {
  getLoginError(state) {
    return state.loginError;
  },
  getUser(state) {
    return state.user;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/User.js